/**
 * @file entry
 * @author Adele Angel
 **/

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// imported components
import Section from '@/components/globals/Section';
// imported styles
import '@/assets/styles/main.scss';

Vue.config.productionTip = false;

// imported FontAwesome Icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
	faCode,
	faMoon,
	faSun,
	faLaptopCode,
	faShareAlt,
	faDatabase,
	faCloud,
	faCodeBranch,
	faCogs,
	faTools,
	faDraftingCompass,
	faBezierCurve,
	faMobileAlt,
	faSearch,
	faChartPie,
	faHandHoldingUsd,
	faChevronUp,
	faEnvelope,
	faHammer,
} from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faXing, faCodepen } from '@fortawesome/free-brands-svg-icons';

// registering the FontAwesome component and adding icons to the library before Vue application bootstrap
Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
	faCode,
	faMoon,
	faSun,
	faLaptopCode,
	faShareAlt,
	faDatabase,
	faCloud,
	faCodeBranch,
	faCogs,
	faTools,
	faDraftingCompass,
	faBezierCurve,
	faMobileAlt,
	faSearch,
	faHandHoldingUsd,
	faChartPie,
	faLinkedin,
	faGithub,
	faXing,
	faCodepen,
	faChevronUp,
	faEnvelope,
	faHammer,
);

// global module
Vue.component('Section', Section);

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
